import { blockType } from "../constants";
import { KanbanBlockSchema } from "../schema";
import type { Kanban } from "../types";

export const create: Kanban["create"] = ({ title } = {}) => {
  return KanbanBlockSchema.parse({
    type: blockType,
    config: {
      title: title ?? "My kanban",
      style: {
        width: "wide",
        alignment: "center",
      },
    },
  });
};
